import initReactApp from 'dpl/util/initReactApp';
import Layout from 'dpl/reviews/components/Layout';
import NewsletterFormContainer from 'dpl/containers/NewsletterFormContainer';
import BreederProfileTestimonialModal from 'dpl/containers/BreederProfile/Index/BreederProfileTestimonialModal';

initReactApp({
  Layout,
  NewsletterFormContainer,
  BreederProfileTestimonialModal
});
